<script module lang="ts">
  interface RichTextProps {
    blok: {
      body: ISbRichtext;
    };
  }
</script>

<script lang="ts">
  import { renderRichText, type ISbRichtext } from '@storyblok/svelte';
  import { css } from '@agapi/ui/panda/css';
  import { richTextStyles } from './rich-text.styles';

  const { blok }: RichTextProps = $props();

  // console.log('richTextBlok', blok);

  const transformBlok = (blok: any) => {
    if (blok.body.content) {
      console.log(blok);
      return renderRichText(blok.body, {
        resolver: (component, blok) => {
          switch (component) {
            case 'table':
              return `<table class="rich-text-table">
                  <thead>
                    <tr>
                    ${blok.content.thead.map((th: any) => {
                      return `<th>${th.value}</th>`;
                    })}
                    </tr>
                    </thead>
                    <tbody>
                    ${blok.content.tbody.map((tr: any) => {
                      return `<tr>
                       ${tr.body.map((td: any) => {
                         return `<td>${td.value}</td>`;
                       })}
                       </tr>`;
                    })}
                  </tbody>
                </table>`;
          }
        }
      });
    }
    console.error('Malformed Object "blok"', blok, 'especting format: { body: {content: [...], ...} (see type ISbRichtext)');
  };

  const articleHTML = $derived(transformBlok(blok));
</script>

{#if articleHTML}
  <div class={css(richTextStyles)}>{@html articleHTML}</div>
{/if}
